// Function to render stars based on rating
export const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating - fullStars >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <>
      {[...Array(fullStars)].map((e, i) => (
        <i
          key={`full-${i}`}
          className="fa fa-star"
          style={{ color: '#FFD700' }}
        />
      ))}
      {halfStar && (
        <i className="fa fa-star-half-o" style={{ color: '#FFD700' }} />
      )}
      {[...Array(emptyStars)].map((e, i) => (
        <i
          key={`empty-${i}`}
          className="fa fa-star-o"
          style={{ color: '#FFD700' }}
        />
      ))}
      &nbsp;({rating.toFixed(1)})
    </>
  );
};
